import React from 'react'
import { Breadcrumb, BreadcrumbItem } from 'shards-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const DynamicBreadcrumb = ({ breadCrumbList }) => {
    const breadCrumbListCopy = [...breadCrumbList]
    const lastItem = breadCrumbListCopy.pop()

    return (
        <Breadcrumb>
            {breadCrumbListCopy.length > 0 &&
                breadCrumbListCopy.map((breadCrumbItem, idx) => (
                    <BreadcrumbItem key={`#breadCrumb-${idx}-${breadCrumbItem.label}`}>
                        <Link to={{ pathname: breadCrumbItem.pathname }}>{breadCrumbItem.label}</Link>
                    </BreadcrumbItem>
                ))}
            <BreadcrumbItem active>{lastItem && lastItem.label ? lastItem.label : ''}</BreadcrumbItem>
        </Breadcrumb>
    )
}

DynamicBreadcrumb.propTypes = {
    breadCrumbList: PropTypes.array,
}

export default DynamicBreadcrumb
